// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'opportunity';

export const Component = () => (
  <path d='m15.9 15.71-3.64 7.231-3.639-7.232h7.28Zm3.927-7.855-3.448 6.848H8.14L4.693 7.855h15.134ZM23.228.958l-2.921 5.89H4.215L1.294.958h21.935Zm1.293-.335V.43c0-.047 0-.096-.048-.096 0-.048 0-.048-.047-.096 0-.048 0-.048-.048-.096s-.048-.048-.096-.048c0-.047 0-.047-.048-.047-.047 0-.047 0-.096-.048H.383C.335.048.335.048.287.048L.239.095.143.143C.095.191.095.191.095.239.048.287.048.287.048.335 0 .335 0 .383 0 .431v.192c.048 0 .048.047.048.096l11.78 23.515v.048l.145.144c.047 0 .047 0 .047.047.048.048.144.048.24.048.095 0 .19 0 .238-.048l.048-.047.144-.144v-.048L24.47.72c0-.048 0-.096.048-.096h.002Z' />
);

export const viewBox = '0 0 25 25';
